import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation
import styles from './App.module.css';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home/Home';
import Projects from './components/Projects/Projects';
import ProjectInfo from './components/Projects/ProjectsList/Project/ProjectInfo/ProjectInfo';
import Footer from './components/Footer/Footer';
import About from './components/About/About';
import Cursor from './components/Cursor/Cursor';
import Navbar from './components/Navbar/Navbar';
import { TranslationProvider } from './TranslationProvider';

const App = () => {
    const location = useLocation(); // Detects route changes
    const [theme, setTheme] = useState('light');
    const [isFooterVisible, setIsFooterVisible] = useState(true);
    const [search, setSearch] = useState<string>('');
    const [hoverProject, setHoverProject] = useState<boolean>(false);
    const [projectTitle, setProjectTitle] = useState<string>("");

    useEffect(() => {
        window.scrollTo(0, 0)
        setTheme('light');
    }, [location]);

    useEffect(() => {
        setHoverProject(false);
        setProjectTitle("");
    }, []);

    return (
        <TranslationProvider>
            <div className={styles.container}>
                <Cursor projectTitle={projectTitle} hoverProject={hoverProject} />
                <Navbar location={location} theme={theme} setSearch={setSearch} />
                <div className={styles.home_scroll}>
                    <Routes>
                        <Route path='/' element={<Home setSearch={setSearch} setIsFooterVisible={setIsFooterVisible} setTheme={setTheme} />} />
                        <Route path='/projects' element={<Projects setProjectTitle={setProjectTitle} setHoverProject={setHoverProject} setSearch={setSearch} search={search} setIsFooterVisible={setIsFooterVisible} />} />
                        <Route path='/projects/:projectId' element={<ProjectInfo setProjectTitle={setProjectTitle} setHoverProject={setHoverProject} setSearch={setSearch} setIsFooterVisible={setIsFooterVisible} />} />
                        <Route path='/about' element={<About setIsFooterVisible={setIsFooterVisible} setSearch={setSearch} />} />
                    </Routes>
                </div>
                {isFooterVisible && <Footer />}
            </div>
        </TranslationProvider>
    );
}

export default App;